
// megamenu sublink images hover
document.addEventListener("DOMContentLoaded", function () {
    const subSubLinks = document.querySelectorAll(".mega-menu__sub-link");
    const megaMenuImages = document.querySelector("#mega-menu__images");

    subSubLinks.forEach(link => {
      const linkId = link.id;
      const imageId = linkId.replace("link-", "image-");
      const image = document.getElementById(imageId);

      link.addEventListener("mouseenter", () => {
        if (image) image.style.display = "block";
        if (megaMenuImages) megaMenuImages.style.display = "none";
      });

      link.addEventListener("mouseleave", () => {
        if (image) image.style.display = "none";
        if (megaMenuImages) megaMenuImages.style.display = "block";
      });
    });
  });

// megamenu class scrolled
window.addEventListener('scroll', function () {
  const menus = document.querySelectorAll('.mega-menu');
  menus.forEach(menu => {
    if (window.scrollY > 20) {
      menu.classList.add('scrolled');
    } else {
      menu.classList.remove('scrolled');
    }
  });
});

